export default __webpack_public_path__ + "static/media/alert-icon.d2da3440.svg";